<template>
  <div
    class="tw-p-1 tw-inline-flex tw-items-center tw-justify-between tw-rounded tw-border tw-border-primary-grey-200 tw-gap-1"
  >
    <div class="tw-flex tw-items-center tw-justify-center">
      <cb-icon-file :width="24" :height="24" />
    </div>
    <div class="tw-overflow-hidden">
      <div class="tw-text-nowrap tw-text-xs tw-font-bold">
        <slot name="name" />
      </div>
      <div
        class="tw-flex tw-justify-between tw-gap-1 tw-text-xs tw-text-primary-grey-700"
      >
        <slot name="extension" />
        <span>
          <slot name="size" />
        </span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
export interface EmailAttachmentProps {
  testId?: string;
}

withDefaults(defineProps<EmailAttachmentProps>(), {
  testId: "cl-attachment-download-link",
});
</script>
